var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSweatDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 170 344",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M84.972,0c0,0 -84.972,180.944 -84.972,258.492c0,46.897 38.075,84.972 84.972,84.972c46.898,0 84.972,-38.075 84.972,-84.972c0,-77.548 -84.972,-258.492 -84.972,-258.492Z",
    style: {
      fill: "#45a3f0"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.972,0c0,0 -84.972,180.944 -84.972,258.492c0,46.897 38.075,84.972 84.972,84.972c46.898,0 84.972,-38.075 84.972,-84.972c0,-77.548 -84.972,-258.492 -84.972,-258.492Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.551,0c-0,0 -84.972,180.944 -84.972,258.492c-0,46.897 38.074,84.972 84.972,84.972c46.897,0 84.972,-38.075 84.972,-84.972c-0,-77.548 -84.972,-258.492 -84.972,-258.492Z",
    style: {
      fill: "#79b6e8"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweatDrop);
export default __webpack_public_path__ + "static/media/sweat-drop.173fe0ca3d721d3cdf0615c817f0f49f.svg";
export { ForwardRef as ReactComponent };